import { ChevronLeft } from 'lucide-react';
import React, { useState } from 'react'
import Registration from './Registration';
import BudgetPlan from './BudgetPlan';
import Configurations from './Configurations';
import MapCampaigns from './MapCampaigns';
import MappedCamapginsList from './MappedCamapginsList';
import Loader from '../../../../../../presentationals/Loader/Loader.component'
export default function Main({ handleBack }) {
    const [saveHandler, setSaveHandler] = useState(null);
    const [tabs, setTabs] = useState("registration");
    const [loader, setLoader] = useState(false);
    const [mapDisabled,setMapDisabled] =useState(true)

    const handleTabs = (type) => {
        setTabs(type)
    }

    const handleSave = async (fn) => {
        console.log("fn", fn)
        if (!fn) return;
        setLoader(true);
        try {
            await fn();
        } catch (err) {
            console.log(err);
        }
        setLoader(false);
    };



    return (
        <>
            <div className='OverView-Main-Section min-size-marketing-1800'>
                {loader ? <Loader /> : ""}
                <div className='custom-tabss' style={{ marginTop: '40px' }}>
                    <button className={`custombtn ${tabs == "registration" ? "active" : ""}`} onClick={() => handleTabs("registration")}>Aggregator</button>
                    <button className={`custombtn ${tabs == "configurationAdd" ? "active" : ""}`} onClick={() => handleTabs("configurationAdd")}>Configuration</button>
                    <button className={`custombtn ${tabs == "budgetPlanAdd" ? "active" : ""}`} onClick={() => handleTabs("budgetPlanAdd")}>Budget Plan</button>
                    {/* <button className={`custombtn ${tabs == "mapcampagins" ? "active" : ""}`} onClick={() => handleTabs("mapcampagins")}>Map Campaigns</button>
                    <button className={`custombtn ${tabs == "MappedCamapginsList" ? "active" : ""}`} onClick={() => handleTabs("MappedCamapginsList")}>Mapped Campaigns</button> */}
                </div>



                <div className='HeadingFilter-Section'>
                    <div>
                        <h4 style={{ display: 'inline-flex', gap: '5px', alignItems: 'center', cursor: 'pointer' }} onClick={() => handleBack("dashboard", "")}><ChevronLeft style={{ width: 'auto' }} /> {
                            tabs == "registration" ? "Aggregator Registration"
                                : tabs == "configurationAdd" ? "Add Configuration"
                                    : tabs == "budgetPlanAdd" ? "Add Budget Plan"
                                        : tabs == "mapcampagins" ? "Map Campaigns"
                                        : tabs == "MappedCamapginsList" ? "Mapped Campaigns"
                                            : ""
                        }</h4>
                    </div>
                    <div className='topsTabs' style={{ border: 'none' }}>
                        <div className='rightTabs' style={{ padding: '0' }}>
                            {
                                tabs !== "MappedCamapginsList" ? 
                                tabs == "mapcampagins" ?
                                    <button className={`rightSideBtn active`} disabled={mapDisabled} style={{ background: '#035865', color: '#fff' ,cursor: mapDisabled ? "no-drop" : "pointer",opacity:mapDisabled ? "0.2" :"1" }} onClick={() => saveHandler && handleSave(saveHandler)}>Map</button>
                                    :
                                    <>
                                        <button className={`rightSideBtn `} style={{ border: '1px solid #035865', color: '#035865' }} onClick={() => handleBack("dashboard", "")}>Cancel</button>
                                        <button className={`rightSideBtn active`} style={{ background: '#035865', color: '#fff' }} onClick={() => saveHandler && handleSave(saveHandler)}>Save</button>
                                    </>
                           :"" }
                        </div>
                    </div>
                </div>

                {
                    tabs == "registration" ?
                        <Registration
                            handleSave={handleSave}
                            setLoader={setLoader}
                            setSaveHandler={setSaveHandler}
                        />
                        : ""}
                {
                    tabs == "budgetPlanAdd" ?
                        <BudgetPlan
                            handleSave={handleSave}
                            setLoader={setLoader}
                            setSaveHandler={setSaveHandler}
                        />
                        : ""}
                {
                    tabs == "configurationAdd" ?
                        <Configurations
                            handleSave={handleSave}
                            setLoader={setLoader}
                            setSaveHandler={setSaveHandler}
                        />
                        : ""}
                {
                    tabs == "MappedCamapginsList" ?
                        <MappedCamapginsList
                            
                            setLoader={setLoader}
                        />
                        : ""}
                {
                    tabs == "mapcampagins" ?
                        <MapCampaigns
                          
                            setLoader={setLoader}
                            setSaveHandler={setSaveHandler}
                            setMapDisabled={setMapDisabled}
                        />
                        : ""}
            </div>
        </>
    )
}
